export enum PakOptimizerState {
  Optimized = 'optimized',
  NotOptimized = 'notOptimize',
  Swap = 'swap',
}
